import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const CommunityTheme = definePreset(Lara, {
  semantic: {
    primary: { 200: '#007BC2',300: '#007BC2', 400: '#007BC2', 500: '#007BC2', 600: '#528BBA', 700: '#3C6F9F' }, // primary button background and hover default 
    // info: { 200: '#07A279',300: '#07A279', 400: '#07A279', 500: '#07A279', 600: '#2d7a5c' }, // background, hover, active
   },
  components: {
  button: {
    root: {
      borderRadius: '6px'
      // height: '35px',
      // width: '535px'
    }
  
    },

    primary: {
      background: 'rgba(0, 123, 194, 1)',
      color: '#ffffff',
      border: { color: 'rgba(0, 123, 194, 1)' },
      hover: {
        background: '#528BBA',
        border: { color: '#528BBA' }
      },
      active: {
        background: '#3C6F9F',
        border: { color: '#3C6F9F' }
      }
    },

    // Solid “info” button (default style)
    info: {
      background: '{info.500}',
      color: '#ffffff',
      border: { color: '{info.500}' },
      hover: { background: '{info.600}', border: { color: '{info.600}' } },
      active: { background: '{info.700}', border: { color: '{info.700}' } }
    },

    // If outlined info buttons:
    outlined: {
      info: {
        color: '{info.500}',
        border: { color: '{info.500}' },
        hover: { color: '{info.600}', border: { color: '{info.600}' } },
        active: { color: '{info.700}', border: { color: '{info.700}' } }
      }
    },

    // If text-only info buttons:
    text: {
      info: {
        color: '{info.500}',
        hover: { color: '{info.600}' },
        active: { color: '{info.600}' }
      }
    }
  }
  
});
